/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';

import { RouteConfiguration } from './routeConfiguration';

import { PermissionGuard } from 'blb-components/AuthenticatedApp/PermissionGuard';

export const styles = StyleSheet.create({
  mainPaneContainer: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'scroll',
  },
});

export namespace MainPaneContainer {
  export interface Props {
    routes: RouteConfiguration[];
  }
}

export const MainPaneContainer: React.FC<MainPaneContainer.Props> = ({ routes }) => {
  return (
    <div className={css(styles.mainPaneContainer)}>
      <Switch>
        {routes.map(({ MainPaneContent, path, permissions }) => (
          <Route exact key={path} path={path}>
            <PermissionGuard requiredPermissions={permissions}>
              <MainPaneContent />
            </PermissionGuard>
          </Route>
        ))}
      </Switch>
    </div>
  );
};
